import React from 'react'
import { Navigate, Routes, Route } from 'react-router-dom'

import DataRoomsOverview from './view/DataRoomsOverview'
import './styles/DataRooms.scss'
import DataRoomsSpaces from './view/DataRoomsSpaces'
import DataRoomsFiles from './view/DataRoomsFiles'
import SpaceAllFiles from './view/SpaceAllFiles'
import SpaceHiddenFiles from './view/SpaceHiddenFiles'
import SpaceTrashFiles from './view/SpaceTrashFiles'
import DataRoomFileView from './view/DataRoomFileView'
import MainFileView from './view/MainFileView'
import MainFileActivityView from './view/MainFileActivityView'
import MainFilePerformanceView from './view/MainFilePerformanceView'
import DataRoomPreview from './view/DataRoomPreview'
import DataRoomSpaceEdit from './view/DataRoomSpaceEdit'

const DataRoomsRoutes = () => {
  return (
    <div>
      <Routes>
        <Route
          path='overview'
          element={
            <>
              {' '}
              <DataRoomsOverview />{' '}
            </>
          }
        />

        <Route
          path='spaces'
          element={
            <>
              <DataRoomsSpaces />
            </>
          }
        />

        <Route
          path='space-edit'
          element={
            <>
              <DataRoomSpaceEdit />
            </>
          }
        >

          <Route
            path='all-files'
            element={
              <>
                <SpaceAllFiles />
              </>
            }
          />

          <Route
            path='all-files/:dataRoomId'
            element={
              <>
                <SpaceAllFiles />
              </>
            }
          />

          <Route
            path='hidden'
            element={
              <>
                {' '}
                <SpaceHiddenFiles />{' '}
              </>
            }
          />

          <Route
            path='hidden/:dataRoomId'
            element={
              <>
                {' '}
                <SpaceHiddenFiles />{' '}
              </>
            }
          />

          <Route
            path='trash'
            element={
              <>
                {' '}
                <SpaceTrashFiles />
              </>
            }
          />

          <Route
            path='trash/:dataRoomId'
            element={
              <>
                {' '}
                <SpaceTrashFiles />
              </>
            }
          />
          <Route index element={<Navigate to='/data-rooms/space-edit/all-files' />} />
        </Route>

        <Route
          path='files'
          element={
            <>
              <DataRoomsFiles />
            </>
          }
        />

        <Route
          path='file-view'
          element={
            <>
              <DataRoomFileView />
            </>
          }
        >
            <Route
              path='main-file-view'
              element={
                <>
                  <MainFileView />
                </>
              }
            >

              <Route
                path='main-file-activity-view/:contentId'
                element={
                  <>
                    <MainFileActivityView />
                  </>
                }
              />
              <Route
              path='main-file-performance-view/:contentId'
              element={
                <>
                  <MainFilePerformanceView />
                </>
              }
            />
          

            </Route>

            <Route
              index
              element={<Navigate to='/data-rooms/file-view/main-file-view/main-file-activity-view' />}
            />

          </Route>
          <Route
            path='view-details'
            element={
              <>
                <DataRoomSpaceEdit />
              </>
            }
          >

            <Route
              path='all-files'
              element={
                <>
                  <SpaceAllFiles />
                </>
              }
            />

            <Route
              path='all-files/:dataRoomId'
              element={
                <>
                  <SpaceAllFiles />
                </>
              }
            />

            <Route
              path='hidden'
              element={
                <>
                  {' '}
                  <SpaceHiddenFiles />{' '}
                </>
              }
            />

            <Route
              path='hidden/:dataRoomId'
              element={
                <>
                  {' '}
                  <SpaceHiddenFiles />{' '}
                </>
              }
            />

            <Route
              path='trash'
              element={
                <>
                  {' '}
                  <SpaceTrashFiles />
                </>
              }
            />

            <Route
              path='trash/:dataRoomId'
              element={
                <>
                  {' '}
                  <SpaceTrashFiles />
                </>
              }
            />
            <Route index element={<Navigate to='/data-rooms/view-details/all-files' />} />
          </Route>
          <Route path='create-data-room' element={<DataRoomSpaceEdit />}></Route>
          <Route path='data-room-preview' element={<DataRoomPreview />}></Route>
      </Routes>
    </div>
  )
}

export default DataRoomsRoutes
